import { render, staticRenderFns } from "./GoalForm.vue?vue&type=template&id=7fb0910a&scoped=true"
import script from "./GoalForm.vue?vue&type=script&lang=ts"
export * from "./GoalForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb0910a",
  null
  
)

export default component.exports